import { PageNotFound } from "@/pages/notFound/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/players/$")({
    component: () => <PageNotFound hideLayout />,
});
